<template>
  <PopoverText
    :value="formattedTimestamp"
    :label="label"
    :customClass="customClass"
    :tooltipText="tooltipText"
    :dataCy="dataCy"
    :maxWidth="maxWidth"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import PopoverText from '@/components/devicePopover/content/popoverText.vue'
import { validateTimestamp } from '@/services/device-status'
import { convertUTCToTSITimezoneDate } from '@/helpers/common/helper'

export default defineComponent({
  name: 'popoverTimestamp',
  components: {
    PopoverText
  },
  props: {
    value: String,
    label: String,
    invalidText: String,
    showTimeZoneDate: Boolean,
    customClass: String,
    maxWidth: String,
    tooltipText: String,
    dataCy: String
  },
  computed: {
    formattedTimestamp(): string {
      const noTS = this.invalidText || this.$t('map.popover.timestamp.lastMeasurementNever')
      const timestamp = validateTimestamp(this.value, noTS)

      if (timestamp !== noTS) {
        return this.showTimeZoneDate
          ? convertUTCToTSITimezoneDate(timestamp)
          : new Date(timestamp).toLocaleString()
      }

      return timestamp
    }
  }
})
</script>
